namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class MaterialPaymentRegisterDialog extends Serenity.TemplatedDialog<any> {
        public isclosed: boolean;
        getTemplate() {
            return `<div id="GridDiv" style="height: 800px;margin:0px 15px 0px"></div>

<script type="text/javascript">
    jQuery(function () {
        new TabAurous.Inventory.MaterialPaymentRegisterGrid($('#GridDiv'), {}).init();

        Q.autoFullHeight($('#GridDiv'));
    });
</script>

<script type="text/javascript" src="/Scripts/apexcharts/apexcharts.js"></script>`
        }
        static selectedboms = [];
        public items = [];
        checkGrid: MaterialPaymentRegisterGrid;
        constructor() {
            super();
            //var gridType = MaterialPaymentRegisterGrid;
            //this.checkGrid = new gridType(this.byId("RowSelectionCheckGrid"));
            this.dialogTitle = "Register : Material Payment";
            //this.checkGrid.element.height(650);
        }

        onSuccess = () => { this.checkGrid.refresh(); return 0; }

        getDialogOptions() {
            let opt = super.getDialogOptions();

            opt.width = 1500;
            return opt
        }
        protected onDialogOpen() {
            jQuery(".ui-dialog-titlebar-maximize").click();
            super.onDialogOpen();

        }

    }
}